<template>
  <div class="progress" v-show="show">
    <div class="progress-bar progress-bar-striped active"
      role="progressbar"
      aria-valuenow="45"
      aria-valuemin="0"
      aria-valuemax="100"
      v-bind:style="{ width: precentage + '%' }">
      <span>{{text}}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["invitations"],
  data() {
    return {
      precentage: 20,
      text: "收集過往應徵者中...",
      show: false
    };
  },
  created() {
    eventHub.$on('job-invitation-start', () => {
      this.run();
    });
  },
  computed: {

  },
  methods: {
    run() {
      this.show = true;

      setTimeout(() => {
        this.text = "收集到 " + this.invitations + " 位應徵者"
        this.precentage = 30;
      }, 1000);

      setTimeout(() => {
        this.text = "寄送通知中...(40%)"
        this.precentage = 40;
      }, 2000);

      setTimeout(() => {
        this.text = "寄送通知中...(60%)"
        this.precentage = 60;
      }, 3000);

      setTimeout(() => {
        this.text = "寄送通知中...(80%)"
        this.precentage = 80;
      }, 3500);

      setTimeout(() => {
        this.text = "全部寄送成功"
        this.precentage = 100;
      }, 4500);

      setTimeout(() => {
        top.location.reload();
      }, 5000);


    }
  }
}
</script>


// WEBPACK FOOTER //
// app/javascript/packs/job_invitation_progress.vue